import { useStepUp } from './useStepUp'

/** An identity change abandons the prompt and the request it was gating. */
export const resetStepUp = (): void => {
  useStepUp().cancel()
}
